import { Grid, List, ListItemButton, Typography } from "@mui/material";
import { getUserClaims } from "features/application/application-slice";
import { fetch_customer_settings } from "features/auto-thunks";
import { setSelectedprocessedMedia } from "features/processedMedia/processedMedia-slice";
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { gridSpacing } from "store/constant";
import rq from 'components/RedQuick';
import TitleService, { GetTimeSince } from "title-service";
import SubCard from "ui-component/cards/SubCard";
import { get_all_customerSettings, get_selected_customerSettings, setSelectedcustomerSettings } from "features/customerSettings/customerSettings-slice";
import SettingsIcon from '@mui/icons-material/Settings';

export default function CustomerSettingsList(props: {}) {
    const dispatch = useDispatch();
    const claims = useSelector(getUserClaims);
    const [filter, setMediaFilter] = useState('');
    const customerSettings_list = useSelector(get_all_customerSettings);
    const customerSetting = useSelector(get_selected_customerSettings);
    useEffect(() => {
        if (claims?.player) {
            dispatch(fetch_customer_settings({
                playerId: claims?.player
            }));
        }
    }, [claims?.player]);

    return (
        <>
            <Grid item xs={12}  >
                <SubCard title={TitleService('Customer Settings')}>
                    <Grid container spacing={gridSpacing}>
                        <rq.RedQuickTextField title={TitleService('Filter')} value={filter || ''} onChange={(val) => {
                            setMediaFilter(val);
                        }} />
                        <Grid item xs={12} sx={{
                            maxHeight: 'calc(72vw)',
                            overflow: 'auto'
                        }}>
                            <List>
                                {(customerSettings_list || []).filter((pm => {
                                    if (filter) {
                                        let name = `${pm.name} ${(pm?.blackListTags || []).join(' ')} ${(pm?.whiteListTags || []).join(' ')}`;

                                        return `${name}`.toLowerCase().indexOf(`${filter}`.toLowerCase()) !== -1;
                                    }
                                    return true;
                                })).map((pm, index) => {
                                    let name = `${pm.name}`;

                                    return (
                                        <ListItemButton key={index} selected={pm?.id === customerSetting?.id} onClick={() => {
                                            dispatch(setSelectedcustomerSettings(pm?.id));
                                        }}>
                                            <Grid item xs={12}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs zeroMinWidth>
                                                        <Typography align="left" component="div" variant="subtitle1">
                                                            {name || pm?.name}
                                                        </Typography>
                                                        <Typography align="left" component="div" style={{
                                                            whiteSpace: 'nowrap',
                                                            maxWidth: 200,
                                                            textOverflow: 'ellipsis',
                                                            overflow: 'hidden'
                                                        }} variant="subtitle2">
                                                            {pm?.name || pm?.id}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography align="left" variant="caption">
                                                            <SettingsIcon sx={{
                                                                fontSize: '0.875rem',
                                                                marginRight: 0.2,
                                                                verticalAlign: 'sub'
                                                            }} />{GetTimeSince(pm.updated)}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </ListItemButton>
                                    )
                                })}
                            </List>
                        </Grid>
                    </Grid>
                </SubCard>
            </Grid>
        </>
    )
}